import { Routes } from "@angular/router";
import { DashboardDefaultComponent } from "../../components/dashboard/default/default.component";
import { ConfiguracoesComponent } from "../../components/configuracoes/configuracoes.component";
import { EmpresasComponent } from "../../components/empresas/empresas.component";

export const content: Routes = [
  {
    path: "dashboard",
    loadChildren: () =>
      import("../../components/dashboard/default.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "empresas",
    component: EmpresasComponent,
  },
  {
    path: "configuracoes",
    component: ConfiguracoesComponent,
  },
];
